import { Card, Col, message } from 'antd';
import React, { useEffect, useState } from 'react';
import Compress from 'react-image-file-resizer';
import BoxImage from '../../../../components/BoxImage';
import { useInspeccionContext } from '../../../../context/inspeccion-context';
import { errorHandler, heicAndheifConvert, isMobile } from '../../../../utils';

export default function TarjetaEdit({ card, imagenes, inspeccion, count }) {
  const [imagen, setImagen] = useState(null);
  const [loading, setLoading] = useState(false);
  const { uploadFile } = useInspeccionContext();

  useEffect(() => {
    loadImage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadImage = () => {
    setLoading(true);
    if (imagenes) {
      Object.keys(imagenes).forEach(function test(key) {
        if (imagenes[key].paso_nro === card.key) {
          setImagen(imagenes[key].url);
        }
      });
    }
    setLoading(false);
  };

  const saveimage = async (file) => {
    try {
      if (isMobile) {
        setLoading(true);
        const response = await uploadFile(file, card.key, inspeccion);
        setImagen(response.data.data);
        count();
        setLoading(false);
      } else {
        errorHandler(null, 'Debe tomar la foto desde un dispositivo móvil');
      }
    } catch (err) {
      // error
    }
  };

  const customRequest = async ({ file }) => {
    const converted = await heicAndheifConvert(file);
    try {
      Compress.imageFileResizer(
        converted, // the file from input
        2400, // width
        1600, // height
        'JPEG', // compress format WEBP, JPEG, PNG
        90, // quality
        0, // rotation
        (uri) => {
          saveimage(uri);
        },
        'blob' // blob or base64 default base64
      );
    } catch (error) {
      message.error(error);
    }
  };

  return (
    <Col key={card.parte} xs={24} sm={12} md={8} lg={6}>
      <Card
        size="small"
        style={{ marginTop: 16 }}
        bodyStyle={{ paddingTop: 8, paddingBottom: 0 }}
        cover={
          <BoxImage
            customRequest={customRequest}
            imagen={imagen || card.image}
            loading={loading || false}
            card={card}
          />
        }
      />
    </Col>
  );
}
